module.exports = __webpack_public_path__ + "static/media/Icona-1.026b2166.svg";